/* eslint-disable react/no-danger */
import React from 'react';
import i18n from '../../utils/I18n';
import InfoUpload from './InfoUpload';
import Globals from '../../utils/Globals';
import { format, parseISO } from 'date-fns';
import Ajax from '../../utils/Ajax';
import '../../css/textpages_screen.scss';
import '../../css/textpages_print.scss';

class Info extends React.Component<
    {},
    {
        error: string;
        infoText: string;
        licence: any;
        config: any;
        editingConfig: boolean;
    }
> {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            infoText: Globals.licence.infoText || '',
            licence: Globals.licence,
            config: null,
            editingConfig: false,
        };
        this.uploadSuccess = this.uploadSuccess.bind(this);
        this.buttonClose = this.buttonClose.bind(this);
        this.buttonPrint = this.buttonPrint.bind(this);
        this.handleConfigChange = this.handleConfigChange.bind(this);
        this.saveConfig = this.saveConfig.bind(this);
        this.toggleConfigEdit = this.toggleConfigEdit.bind(this);
    }

    async componentDidMount() {
        // Fetch config data
        const Actions = Globals.actions;
        if (!Actions || !Actions.can('user.admin.global')) return;
        try {
            const data = await Ajax.getJson('config/getConfig');
            this.setState({ config: data });
        } catch (error) {
            this.setState({ error: 'Failed to load config: ' + error.message });
        }
    }

    uploadSuccess(data) {
        this.setState({ infoText: data.infoText, licence: data });
    }

    buttonPrint() {
        window.print();
        console.log(this);
    }

    buttonClose() {
        window.history.back();
        console.log(this);
    }

    async saveConfig() {
        try {
            await new Ajax().post({ url: 'config/updateConfig', json: this.state.config, method: 'PUT' });
            this.setState({ editingConfig: false, error: '' });
        } catch (error) {
            this.setState({ error: 'Failed to save config: ' + error.message });
        }
    }

    handleConfigChange(key: string, value: any) {
        this.setState((prevState) => ({
            config: {
                ...prevState.config,
                [key]: value,
            },
        }));
    }

    toggleConfigEdit() {
        this.setState((prevState) => ({
            editingConfig: !prevState.editingConfig,
        }));
    }

    renderConfig() {
        if (!this.state.config) return null;

        // Sort config entries alphabetically by key
        const sortedConfig = Object.entries(this.state.config).sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
        const Actions = Globals.actions;
        if (!Actions || !Actions.can('user.admin.global')) return null;
        return (
            <>
                <hr />
                {this.state.error && <p>{this.state.error}</p>}
                <div className="config-header">
                    <h2>{i18n.t('config.header').toString()}</h2>
                    <button onClick={this.toggleConfigEdit} className="defaultButton buttonAutoFlat">
                        {this.state.editingConfig ? i18n.t('config.cancel').toString() : i18n.t('config.edit').toString()}
                    </button>
                    {this.state.editingConfig && (
                        <button onClick={this.saveConfig} className="defaultButton buttonAutoFlat">
                            {i18n.t('config.save').toString()}
                        </button>
                    )}
                </div>
                <div className="config-section">
                    {sortedConfig.map(([key, value]) => (
                        <div key={key} className="config-item">
                            <strong>{key}:</strong>
                            {this.state.editingConfig ? (
                                <input type="text" value={value as string} onChange={(e) => this.handleConfigChange(key, e.target.value)} className="config-input" />
                            ) : (
                                <span>{JSON.stringify(value)}</span>
                            )}
                        </div>
                    ))}
                </div>
            </>
        );
    }

    render() {
        var licence = this.state.licence;
        return (
            <div style={{ textAlign: 'left' }}>
                <div className="infopage">
                    {this.state.error && <p>{this.state.error}</p>}
                    <h1>{i18n.t('licence.header').toString()}</h1>
                    <p>
                        <strong>{i18n.t('licence.address.header').toString()}</strong>
                    </p>
                    <p>
                        maBinso software GmbH
                        <br />
                        Schellerdamm 16
                        <br />
                        21079 Hamburg
                        <br />
                        <a href="https://www.mabinso.com" target="_blank" rel="noopener noreferrer">
                            www.mabinso.com
                        </a>
                    </p>

                    <p>{i18n.t('licence.description.p1').toString()}</p>
                    <p>{i18n.t('licence.description.p2').toString()}</p>
                    <p dangerouslySetInnerHTML={{ __html: this.state.infoText }}></p>
                    {licence && licence.activePeriod ? (
                        <>
                            <p>{i18n.t('licence.activePeriod').toString()}</p>
                            <p>
                                {licence.activePeriod.startDate.split(' ')[0]} - {licence.activePeriod.endDate.split(' ')[0]}{' '}
                                {licence.activePeriod.vehicleQuantity > 0 && i18n.t('licence.vehicles', { vehicleQuantity: licence.activePeriod.vehicleQuantity }).toString()}
                            </p>
                            <p>{i18n.t('licence.remainingDays', { remainingDays: licence.remainingDays }).toString()}</p>
                            <p>{i18n.t('licence.remainingScheme', { remainingScheme: licence.remainingScheme, totalScheme: licence.activePeriod.serverSchemeQuantity }).toString()}</p>
                            <p>{i18n.t('licence.remainingTestScheme', { remainingTestScheme: licence.remainingTestScheme, totalTestScheme: licence.activePeriod.testSchemeQuantity }).toString()}</p>
                            <p>
                                {i18n
                                    .t('licence.remainingVehicles', {
                                        remainingVehicles: licence.remainingVehicles != null ? licence.remainingVehicles : '?',
                                        vehicleQuantity: licence.activePeriod.vehicleQuantity,
                                    })
                                    .toString()}
                            </p>
                        </>
                    ) : (
                        <p>{i18n.t('licence.noActivePeriod').toString()}</p>
                    )}
                    {this.renderConfig()}
                    <hr />
                    <p>
                        <strong>{i18n.t('licence.other.strong').toString()}</strong>
                    </p>

                    <ul className="licenseul">
                        <li>
                            ALv2 (
                            <a href="http://www.apache.org/licenses/LICENSE-2.0" target="_blank" rel="noopener noreferrer">
                                http://www.apache.org/licenses/LICENSE-2.0
                            </a>
                            ):{' '}
                            <small>
                                Asyncweb, Cglib, Commons Digester, Crossfilter, DC, Eclipse compiler, Ehcache, Ezmorph, Geronimo Servlets, Groovy, GSon, Jakarta commons components, Joda Time,
                                JQtextile, JSR 107 Cache, Log4J, Log4Net, Netty, Snake YAML, Signpost, POI, Play!, Saiku, Flotr2
                            </small>
                        </li>
                        <li>
                            ANTLR (
                            <a href="http://www.antlr.org/license.html" target="_blank" rel="noopener noreferrer">
                                http://www.antlr.org/license.html
                            </a>
                            ): <small>antlr</small>
                        </li>
                        <li>
                            BSD (
                            <a href="http://www.opensource.org/licenses/bsd-license.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/bsd-license.php
                            </a>
                            ): <small>Imaging, Jamon, Jaxen, JRegex, Leaflet, leaflet-image, Simple Captcha</small>
                        </li>
                        <li>
                            BSD (3 clause) (
                            <a href="https://opensource.org/licenses/BSD-3-Clause" target="_blank" rel="noopener noreferrer">
                                https://opensource.org/licenses/BSD-3-Clause
                            </a>
                            ): <small>D3</small>
                        </li>
                        <li>
                            CPL (
                            <a href="http://www.opensource.org/licenses/cpl1.0.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/cpl1.0.php
                            </a>
                            ):
                            <small>JUnit</small>
                        </li>
                        <li>
                            DOM4J (
                            <a href="http://www.dom4j.org/license.html" target="_blank" rel="noopener noreferrer">
                                http://www.dom4j.org/license.html
                            </a>
                            ): <small>Dom4J</small>
                        </li>
                        <li>
                            EPL (
                            <a href="http://www.eclipse.org/legal/epl-v10.html" target="_blank" rel="noopener noreferrer">
                                http://www.eclipse.org/legal/epl-v10.html
                            </a>
                            ): <small>H2 Database, Oval, WikiText, Modrian</small>
                        </li>
                        <li>
                            ISC (
                            <a href="https://opensource.org/licenses/ISC" target="_blank" rel="noopener noreferrer">
                                https://opensource.org/licenses/ISC
                            </a>
                            ): <small>rapid.js</small>
                        </li>
                        <li>
                            LGPL (
                            <a href="http://www.gnu.org/licenses/lgpl.html" target="_blank" rel="noopener noreferrer">
                                http://www.gnu.org/licenses/lgpl.html
                            </a>
                            ): <small>c3p0, Hibernate, iText, Jasper Reports Library, JCommon, JFreeChart</small>
                        </li>
                        <li>
                            MIT (
                            <a href="http://www.opensource.org/licenses/mit-license.php" target="_blank" rel="noopener noreferrer">
                                http://www.opensource.org/licenses/mit-license.php
                            </a>
                            ):{' '}
                            <small>
                                Axios, cypress, Font Awesome, html2canvas, immutability-helper, jest, jquery.contextmenu, jquery.form, jquery.i18n.properties, jquery.layout, jquery.scrollTo-min,
                                jquery.simplemodal-min, jquery.tagsinput, jquery-ui-timepicker-addon, jquery.validationEngine, leaflet-extra-markers, leaflet-polylineoffset, leaflet.export,
                                leaflet.tilelayer.colorfilter, MomentJS, mdn-polyfills, node-sass, query-string, React, react-app-polyfill, react-color, react-datepicker, react modal,
                                react-number-format, react-router, react-select, react-simple-checkbox, react-svg-inline, react-table, resolve, sass-loader, SLF4J, Spy Memcached, sDashboard,
                                style-loader, Underscore, url-loader, validator
                            </small>
                        </li>
                        <li>
                            MPL (
                            <a href="http://www.mozilla.org/MPL/MPL-1.1.html" target="_blank" rel="noopener noreferrer">
                                http://www.mozilla.org/MPL/MPL-1.1.html
                            </a>
                            ): <small>Javassist</small>
                        </li>
                    </ul>
                    <div className="buttonsfooter">
                        <InfoUpload success={this.uploadSuccess} />
                        <button ref="#" onClick={this.buttonPrint} className="defaultButton buttonAutoFlat">
                            {i18n.t('licence.button.print').toString()}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Info;
